import { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Body from '../../../components/Content/Content';
// import PaymentHeader from '../../../components/PaymentHeader/PaymentHeader';
import {
	getCreate,
	// getForm,
	// getPaymentOptionsData,
	getPreorderData,
	getStage,
} from '../../../redux/PreorderSlice/PreorderSelectors';
import { RemoteStatus } from '../../../redux/SharedTypes';
import PreorderTravelRule from './PreorderTravelRule/PreorderTravelRule';
import PreorderCurrencySelect from './PreorderCurrencySelect/PreorderCurrencySelect';
import PreorderNetworkSelect from './PreorderNetworkSelect/PreorderNetworkSelect';
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';

import styles from './PreorderView.module.scss';
import { PreorderStage } from '../../../redux/PreorderSlice/PreorderSlice';
import { MerchantOrderStatus } from '../../../interfaces/MerchantOrder';

const messages = defineMessages({
	metaDescription: {
		id: 'payments.preorder_meta',
		defaultMessage: 'Pre-Order information',
	},
});

const InnerContent: FC = () => {
	const stage = useSelector(getStage);
	switch (stage) {
		case PreorderStage.TravelRule:
			return <PreorderTravelRule />;
		case PreorderStage.CurrencySelect:
			return <PreorderCurrencySelect />;
		case PreorderStage.NetworkSelect:
			return <PreorderNetworkSelect />;
		default:
			return null;
	}
};

const PreorderView: FC = () => {
	const { locale, formatMessage } = useIntl();
	const { projectName, isMultiple, merchantOrderId } = useSelector(getPreorderData)!;
	// const { payCurrency } = useSelector(getForm);
	// const paymentOptions = useSelector(getPaymentOptionsData);
	const { push, replace } = useHistory();
	const { data: createdOrder, status: createStatus } = useSelector(getCreate);
	const stage = useSelector(getStage);

	useEffect(() => {
		if (!createdOrder || createStatus !== RemoteStatus.Done) return;
		if (!createdOrder.depositAddress && createdOrder.status === MerchantOrderStatus.NEW) {
			window.location.assign(`/${locale}/payments/orders/${createdOrder.id}`);
			return;
		}
		if (isMultiple) push(`/${locale}/payment/order/${createdOrder.id}`);
		else replace(`/${locale}/payment/order/${createdOrder.id}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [createStatus]);

	useEffect(() => {
		if (merchantOrderId) {
			replace(`/${locale}/payment/order/${merchantOrderId}`);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [merchantOrderId]);

	return (
		<>
			<Helmet
				htmlAttributes={{ lang: locale }}
				title={`SpectroCoin - ${formatMessage(messages.metaDescription)}`}
				meta={[{ name: 'description', content: formatMessage(messages.metaDescription) }]}
			/>
			<Body name={projectName}>
				<div className={styles.container}>
					<StepProgressBar totalSteps={3} currentStep={stage} />
				</div>
				<InnerContent />
			</Body>
		</>
	);
};

export default PreorderView;
